import React, { useState, useMemo, useContext, useEffect } from "react";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  ListSubheader,
  TextField,
  InputAdornment,
} from "@mui/material";import SearchIcon from "@mui/icons-material/Search";
import FilterContext from "../StateManagement/Context";

const EnterpriseMenu = ({
  enterprises,
  needAll,
  handleEnterpriseChange
}) => {
  const { caseListFilters, updateCaseFilters } = useContext(FilterContext);
  const containsText = (text, searchText) =>
    text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

  const [searchText, setSearchText] = useState("");

  const handleEnterpriseOptionChange = (updatedOption) => {
    if (updatedOption === "All") {
      updatedOption = undefined;
    }
    
    handleEnterpriseChange(updatedOption);
  };

  return (
    <Box>
      <FormControl sx={{ width: 150 }} size="small">
        <InputLabel id="search-select-label">Enterprise</InputLabel>
        <Select
          MenuProps={{
            autoFocus: false,
            style: {
              maxHeight: 400,
            },
          }}
          labelId="search-select-label"
          id="search-select"
          value={caseListFilters.selectedEnterprise || ""}
          label="Enterprise"
          onChange={(e) => handleEnterpriseOptionChange(e.target.value)}
          onClose={() => setSearchText("")}
          renderValue={() => caseListFilters.selectedEnterprise}
        >
          <ListSubheader>
            <TextField
              size="small"
              autoFocus
              placeholder="Type to search..."
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          {needAll && (
            <MenuItem value={"All"}>
              <em>All</em>
            </MenuItem>
          )}

          {enterprises
            .filter((enterprise) => containsText(enterprise, searchText))
            .map((option, i) => (
              <MenuItem key={i} value={option}>
                {option}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default EnterpriseMenu;
